import clsx from 'clsx'
import Link from 'next/link'
import { ComponentPropsWithoutRef, CSSProperties, ReactNode } from 'react'

import cl from './underline-link.module.scss'

type StyleWithVars = CSSProperties & { '--al-bottom'?: string }

type UnderlineLinkProps = ComponentPropsWithoutRef<typeof Link> & {
	children: ReactNode
	active?: boolean
	disableUnderline?: boolean
	underlineOffset?: number
}

export const UnderlineLink = ({
	children,
	className,
	active,
	disableUnderline,
	underlineOffset,
	style,
	...props
}: UnderlineLinkProps) => {
	const offsetStyle: StyleWithVars = {
		...(underlineOffset !== undefined && { '--al-bottom': `${underlineOffset}px` }),
		...style
	}

	return (
		<Link
			prefetch={false}
			{...props}
			style={offsetStyle}
			className={clsx(
				{
					[cl.link]: !disableUnderline,
					[cl.link_active]: !disableUnderline && active
				},
				className
			)}>
			{children}
		</Link>
	)
}
